import Repository from "./Repository";

export default {
  /**
   * 設定取得 (表示用) ※public
   * @param {*} shopId 
   * @returns 
   */
  getSettings (shopId) {
    const config = {
      headers: {
      },
    };
    return Repository.get(`/${shopId}/settings`, config);
  },

  /**
   * Firebase Auth カスタムトークン作成
   * @param {*} lineToken 
   * @returns 
   */
  getCustomToken (shopId, lineToken) {
    const config = {
      headers: {
        lineToken: lineToken ?? "",
      },
    };
    return Repository.get(`/${shopId}/customToken`, config);
  },
  isServiceStatusActive (shopId, headers) {
    const config = {
      headers: this._createHeaders(headers),
    };
    return Repository.get(`/${shopId}/serviceStatusActive`, config);
  },
  getReceivableSetting (shopId, headers) {
    const config = {
      headers: this._createHeaders(headers),
    };
    return Repository.get(`/${shopId}/receivableSetting`, config);
  },
  validateVisitTime (shopId, headers, params) {
    const config = {
      headers: this._createHeaders(headers),
    };
    const query = `visitTimeYMD=${params.visitTimeYMD}&visitTimeHHMM=${params.visitTimeHHMM}`;
    return Repository.get(`/${shopId}/validateVisitTime?${query}`, config);
  },
  getUserOrderStatusRecent (shopId, headers) {
    const config = {
      headers: this._createHeaders(headers),
    };
    return Repository.get(`/${shopId}/order/userOrderStatus/recent`, config);
  },
  checkItemsInCart (shopId, headers) {
    const config = {
      headers: this._createHeaders(headers),
    };
    return Repository.get(`/${shopId}/cart/checkItems`, config);
  },

  /**
   * 注文が通っているかどうか
   * @param {*} shopId 
   * @param {*} headers 
   * @param {*} params 
   * @returns 
   */
  isOrderPassed (shopId, headers, params) {
    const config = {
      headers: this._createHeaders(headers),
    };
    return Repository.get(`/${shopId}/order/passed?orderCartId=${params.orderCartId}`, config);
  },

  /**
   * カートID 更新
   * @param {*} shopId 
   * @param {*} headers 
   * @returns 
   */
  updateCartId (shopId, headers) {
    const config = {
      headers: this._createHeaders(headers),
    };
    const params = {};
    return Repository.put(`/${shopId}/cart/cartId`, params, config);
  },

  /**
   * カート 注文方法 更新
   * @param {*} shopId 
   * @param {*} headers 
   * @param {*} params 
   * @returns 
   */
  updateCartOrderWay (shopId, headers, params) {
    const config = {
      headers: this._createHeaders(headers),
    };
    const data = params;
    return Repository.put(`/${shopId}/cart/orderWay`, data, config);
  },

  /**
   * カートデータ 取得
   * @param {*} shopId 
   * @param {*} headers 
   * @param {*} params 
   * @returns 
   */
  getCartData (shopId, headers) {
    const config = {
      headers: this._createHeaders(headers),
    };
    return Repository.get(`/${shopId}/cart`, config);
  },

  /**
   * カートメニュー 取得
   * @param {*} shopId 
   * @param {*} headers 
   * @param {*} params 
   * @returns 
   */
  getCartMenu (shopId, headers, params) {
    const config = {
      headers: this._createHeaders(headers),
    };
    return Repository.get(`/${shopId}/cart/menus/${params.cartMenuId}`, config);
  },

  /**
   * カートメニュー 追加
   * @param {*} shopId 
   * @param {*} headers 
   * @param {*} params 
   * @returns 
   */
  addCartMenu (shopId, headers, params) {
    const config = {
      headers: this._createHeaders(headers),
    };
    const data = params;
    return Repository.post(`/${shopId}/cart/menus`, data, config);
  },

  /**
   * カートメニュー 編集
   * @param {*} shopId 
   * @param {*} headers 
   * @param {*} params 
   * @returns 
   */
  editCartMenu (shopId, headers, params) {
    const config = {
      headers: this._createHeaders(headers),
    };
    const data = params;
    return Repository.put(`/${shopId}/cart/menus/${params.cartMenuId}`, data, config);
  },

  /**
   * カートメニュー 削除
   * @param {*} shopId 
   * @param {*} headers 
   * @param {*} params 
   * @returns 
   */
  deleteCartMenu (shopId, headers, params) {
    const config = {
      headers: this._createHeaders(headers),
    };
    return Repository.delete(`/${shopId}/cart/menus/${params.cartMenuId}`, config);
  },

  /**
   * 注文履歴(一覧) 取得
   * @param {*} shopId 
   * @param {*} headers 
   * @returns 
   */
  getHistoryOrders (shopId, headers) {
    const config = {
      headers: this._createHeaders(headers),
    };
    return Repository.get(`/${shopId}/order-history`, config);
  },

  /**
   * 注文履歴(詳細) 取得
   * @param {*} shopId 
   * @param {*} headers 
   * @param {*} params 
   * @returns 
   */
  getHistoryOrder (shopId, headers, params) {
    const config = {
      headers: this._createHeaders(headers),
    };
    return Repository.get(`/${shopId}/order-history/${params.orderId}`, config);
  },

  /**
   * 注文履歴(カートID) 取得
   * @param {*} shopId 
   * @param {*} headers 
   * @param {*} params 
   * @returns 
   */
  getHistoryOrderByCartId (shopId, headers, params) {
    const config = {
      headers: this._createHeaders(headers),
    };
    return Repository.get(`/${shopId}/order-history/cart/${params.cartId}`, config);
  },

  /**
   * 注文履歴 メニュー取得
   * @param {*} shopId 
   * @param {*} headers 
   * @param {*} params 
   * @returns 
   */
  getHistoryMenu (shopId, headers, params) {
    const config = {
      headers: this._createHeaders(headers),
    };
    return Repository.get(`/${shopId}/order-history/${params.orderId}/menus/${params.orderMenuId}`, config);
  },

  /**
   * 後払い
   * @param {*} shopId 
   * @param {*} headers 
   * @param {*} params 
   * @returns 
   */
  payAfter (shopId, headers, params) {
    const config = {
      headers: this._createHeaders(headers),
    };
    const data = params
    return Repository.post(`/${shopId}/order/payAfter`, data, config);
  },

  /**
   * ヘッダ作成
   * @param {*} headers 
   * @returns 
   */
  _createHeaders (headers) {
    return {
      lineToken: headers?.lineToken ?? "",
      idToken: headers?.idToken ?? "",
    };
  }
}
